<template>
    <div class="container-fluid justify-content-center">
        <div class="card card-default">
            <div class="card-header">User settings</div>

            <div class="card-body">
                <div v-if="loading"><img src="/loading.svg"> Loading...</div>
                <div v-else>
                    <validation-observer ref="observer" v-slot="{ passes }">
                        <form @submit.stop.prevent="passes(updateUser)">
                            <label>Name</label>
                            <validation-provider name="name" rules="min:3|required" v-slot="{ errors }">
                                <b-form-input v-model="user.name"></b-form-input>
                                <span class="validation">{{ errors[0] }}</span>
                            </validation-provider>

                            <label class="mt-3">Email <span v-if="user.email_verified_at === null">(Not verified - <a href="#" @click="resendVerification">Resend the verification</a>)</span></label>
                            <validation-provider name="email" rules="email|required" v-slot="{ errors }">
                                <b-form-input v-model="user.email"></b-form-input>
                                <span class="validation">{{ errors[0] }}</span>
                            </validation-provider>

                            <button type="submit" class="btn btn-success  mt-2">Save</button>
                        </form>
                    </validation-observer>
                </div>
            </div>
        </div>

        <div class="card card-default">
            <div class="card-header">Password</div>

            <div class="card-body">
                <div v-if="loading"><img src="/loading.svg"> Loading...</div>
                <div v-else>
                    <validation-observer ref="observer" v-slot="{ passes }">
                        <form @submit.stop.prevent="passes(updateUser)">
                            <label>New password</label>
                            <validation-provider name="Password" rules="required|min:6|max:50" v-slot="{ errors }" vid="password">
                                <b-form-input type="password" autocomplete="new-password" v-model="password" ></b-form-input>
                                <span class="validation">{{ errors[0] }}</span>
                            </validation-provider>

                            <label class="mt-4">Confirm new password</label>
                            <validation-provider name="Password confirmation" rules="confirmed:password" v-slot="{ errors }">
                                <b-form-input type="password" autocomplete="new-password" v-model="confirmPassword"></b-form-input>
                                <span class="validation">{{ errors[0] }}</span>
                            </validation-provider>

                            <button type="submit" class="btn btn-success  mt-2">Save</button>
                        </form>
                    </validation-observer>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import NotificationPop from '../mixins/NotificationPop.js'

    export default {
        mixins: [NotificationPop],
        data: () => ({
            // generic
            user: {
            },
            loading: true,
            password: null,
            confirmPassword: null,
        }),
        async created() {
            this.$http.get('/user/' + this.$auth.user().id)
                .then(({data}) => {
                    this.loading = false
                    this.user = data.data
                })
                .catch(error => {
                    this.loading = true
                    console.log(error.response)
                    this.popNotification('Could not load your user', 'danger')
                })
        },
        methods: {

            /**
             * Update user
             */
            updateUser: function () {
                this.loadingUser = true

                // validate that password has been updated correctly
                if(this.password !== this.confirmPassword) {
                    this.password = null
                }

                this.$http.put('/user/' + this.$auth.user().id,
                    {
                        name: this.user.name,
                        email: this.user.email,
                        password: this.password,
                    })
                    .then(({data}) => {
                        if(data.error !== undefined) {
                            this.popNotification(data.error, 'danger')
                        } else {
                            this.popNotification('UserResource is updated', 'success')
                            this.user = data.data // update the current account data

                            // clear passwords
                            if(this.password) {
                                this.password = null
                                this.confirmPassword = null
                                this.$nextTick(() => this.$refs.observer.reset()); // clear any errors
                            }
                        }

                        this.$auth.fetch(); //Fetch fresh user data to update the number of sites

                        this.loadingUser = false
                    })
                    .catch(error => {
                        // handle authentication and validation errors here
                        console.log(error)
                        this.popNotification('Could not update your user', 'danger')
                    })
            },

            /**
             * Resend verification for emails
             */
            resendVerification: function () {
                this.$http.post('/user/resend_verification')
                    .then(() => {
                        this.askToResendVerification = false
                        this.popNotification('Verification email sent. Please also check your SPAM box.', 'success')
                    })
                    .catch(error => {
                        // handle authentication and validation errors here
                        console.log(error)
                        if(error.response.status === 429) {
                            this.askToResendVerification = false
                            this.popNotification('Just sent the verification email.', 'warning')
                        } else {
                            this.popNotification('Could not request new verification email', 'danger')
                        }
                    })
            },

        }
    }
</script>
